import Pagination from './Pagination.vue';

export { Pagination };
export default Pagination;
